import React from 'react';
import ReviewForm from './ReviewForm';

interface SubmitReviewModalProps {
  isOpen: boolean;
  onClose: () => void;
  businessId: string;
  businessName: string;
  bookingId?: string;
  onReviewSubmitted?: () => void;
}

const SubmitReviewModal: React.FC<SubmitReviewModalProps> = ({
  isOpen,
  onClose,
  businessId,
  businessName,
  bookingId,
  onReviewSubmitted
}) => {
  const handleReviewSubmitted = () => {
    onReviewSubmitted?.();
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 bg-black bg-opacity-50 flex items-center justify-center p-4">
      <div className="bg-white rounded-2xl max-w-2xl w-full max-h-[90vh] overflow-y-auto">
        <div className="p-6">
          {/* Header */}
          <div className="flex items-center justify-between mb-6">
            <h2 className="text-2xl font-bold text-gray-900">
              Write a Review
            </h2>
            <button
              onClick={onClose}
              className="text-gray-400 hover:text-gray-600 transition-colors p-2 hover:bg-gray-100 rounded-full"
              aria-label="Close modal"
            >
              <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
          </div>

          {/* Review Form */}
          <ReviewForm
            businessId={businessId}
            businessName={businessName}
            bookingId={bookingId}
            onReviewSubmitted={handleReviewSubmitted}
            onCancel={onClose}
          />
        </div>
      </div>
    </div>
  );
};

export default SubmitReviewModal;